import React from "react";
import { FOKUSTYP_META } from "@/components/FokustypGlyphs";
import { IchSeite, GegenueberSeite } from "@/components/begegnung/BegegnungSeiten";

export default function BegegnungVisual({ begegnung, isPro }) {
  if (!begegnung) return null;
  const { ich, gegenueber } = begegnung;
  const a = FOKUSTYP_META[ich.fokustyp];
  const b = FOKUSTYP_META[gegenueber.fokustyp];
  return (
    <section data-testid="begegnung-visual" data-plan={isPro ? "pro" : "free"}
      className="rounded-lg border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/60 p-5 sm:p-6">
      <p className="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-4">Wer hat es mit wem zu tun?</p>
      <div className="grid grid-cols-[1fr_auto_1fr] items-start gap-3 sm:gap-6">
        <IchSeite ich={ich} isPro={isPro} />
        <div className="pt-6 sm:pt-8 flex flex-col items-center text-slate-400 dark:text-slate-500">
          <span className="block w-8 sm:w-14 border-t-2 border-dashed border-current" />
          <span className="mt-1 text-[10px] uppercase tracking-widest">trifft</span>
        </div>
        <GegenueberSeite gegenueber={gegenueber} isPro={isPro} />
      </div>
      {isPro && a && b && (
        <p data-testid="begegnung-dynamik" className="mt-4 text-center text-sm text-slate-600 dark:text-slate-300">
          <strong className="text-slate-900 dark:text-white">{a.name} trifft {b.name}</strong> · {a.tagline} begegnet {b.tagline}
        </p>
      )}
    </section>
  );
}
